import { Component, OnDestroy, OnInit } from '@angular/core'
import { RouterLink } from '@angular/router'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { Subscription } from 'rxjs'

import { BranchBaseAbstract } from '../../components/branch-base/branch-base.abstract'
import { BranchBaseComponent } from '../../components/branch-base/branch-base.component'
import { ButtonComponent } from '../../components/button/button.component'
import { PageHeadlineComponent } from '../../components/page-headline/page-headline.component'
import { ValueFilterComponent } from '../../components/value-filter/value-filter.component'
import { TypedTemplateDirective } from '../../directives/typed-template.directive'
import { BranchStatus } from '../../models/branch.model'
import { Expression } from '../../repositories/base.repository'
import { BranchRepository } from '../../repositories/branch/branch.repository'

@Component({
  selector: 'app-upload',
  standalone: true,
  imports: [
    ButtonComponent,
    SvgIconComponent,
    TranslatePipe,
    RouterLink,
    ValueFilterComponent,
    PageHeadlineComponent,
    BranchBaseComponent,
    TypedTemplateDirective,
  ],
  templateUrl: './upload.component.html',
})
export class UploadComponent
  extends BranchBaseAbstract
  implements OnInit, OnDestroy
{
  private subscription!: Subscription

  protected override defaultFilter: Expression = {
    name: 'state',
    val: [
      'WORKFLOW_INITIAL',
      'WORKFLOW_UPLOAD_PROCESSED',
      'WORKFLOW_IN_REVIEW',
      'WORKFLOW_EDITING_CONFLICTS',
      'WORKFLOW_MERGING',
      'WORKFLOW_FINISHED',
    ],
    op: 'in',
  }

  public constructor(
    protected override readonly branchRepository: BranchRepository,
    protected override readonly translateService: TranslateService
  ) {
    super(branchRepository, translateService)
  }

  public ngOnInit(): void {
    this.updateTableData()

    this.translateOptionsKeys([
      {
        label: 'pages.uploads.filter.all',
        value: 'all',
      },
      ...(
        [
          'WORKFLOW_UPLOAD_PROCESSED',
          'WORKFLOW_IN_REVIEW',
          'WORKFLOW_EDITING_CONFLICTS',
          'WORKFLOW_FINISHED',
        ] satisfies BranchStatus[]
      ).map((state) => ({
        label: 'models.branch.state.options.' + state,
        value: state,
      })),
    ])
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe()
  }

  protected updateTableData(): void {
    this.isLoading = true
    this.subscription = this.fetchTableData().subscribe()
  }
}
